import { DOCUMENT } from '@angular/common';
import { inject, InjectionToken } from '@angular/core';
import { Request } from 'express';

export const REQUEST = new InjectionToken<Request>('Global request object');

export const requestFactory = (): Request => {
  const location = inject(DOCUMENT)?.location;

  return {
    originalUrl: location.href,
    protocol: location.protocol.replace(':', ''),
    hostname: location.hostname,
    path: location.pathname,
    headers: {
      cookie: document.cookie,
    },
    get: (name) => location.hostname + ':' + location.port
  } as Request
}
